import React, { useEffect, useState } from "react";
import Pagination from '@/components/Pagination';
import Loader from '@/components/Loader';
import EditableTable from "./Table";
import Modal from "@/components/Modal"
import ChangeLog from "@/components/ChangeLog";
import api from "@/auth/api";
import { alertSuccess, alertError } from '@/components/Alert';
import Add from "./Add";

export default function SpamType({editable}) {
  const [data, setData] = useState([]);
  const [changeLogData,setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['title', 'status'];
  const [addDis, setAddDis] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);



  const fetchData = async () => {
    try {
      const response = await api.get("/PanelHome/panel/spamType");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
   const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    try {
      const finalData = {
        id:editedData.id,
        title:editedData.title
      }
      console.log(finalData)
      await api.patch(`/PanelHome/panel/spamType`,finalData);
      alertSuccess("Data updated successfully");
      setEditRowId(null);
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors)
      console.error("Error updating data:", error);
    }

  };

  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };


  
  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };


  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];




  if (loading) return <Loader />;

  return (

    <>
    <div className="flex flex-col items-center p-6 pt-2">
    {/* <h1 className="text-xl m-4 font-semibold">Spam Type</h1> */}
    
    <div className="w-full flex items-center flex-col">        
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        fetchData={fetchData}
        editable={editable}
      />

      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        {editable && 
                <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Pre-Survey Check
        </button>
        }

      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />


      <Modal isOpen={addDis} onClose={()=>setAddDis(false)} title="Add Pre-Survey Check" content={<Add onSuccess={fetchData} />}/>
      
    </div>
        </div>
    </>
 
  );
}
